(function () {
  'use strict';
  function reveal() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
    const target = id && document.getElementById(id);
    if (!target || !target.closest('.wbf-consolidated-page')) return;
    const directory = target.closest('[data-directory]');
    const filter = directory?.querySelector('[data-directory-filter]');
    if (filter?.value) { filter.value = ''; filter.dispatchEvent(new Event('input')); }
    let current = target;
    while (current) {
      if (current.tagName === 'DETAILS') current.open = true;
      current = current.parentElement;
    }
    target.scrollIntoView({block: 'start'});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
  window.addEventListener('hashchange', reveal);
  document.addEventListener('shopify:section:load', reveal);
}());
